import React from 'react';

const LoadingSpinner: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900 flex items-center justify-center">
      <div className="text-center">
        <div className="w-16 h-16 border-4 border-cyan-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <div className="text-2xl font-bold text-white mb-2">SUI-ndicate</div>
        <div className="text-slate-400">Loading the future of racing...</div>
      </div>
    </div>
  );
};

export default LoadingSpinner;
